
	<div class="row" [hidden]="msgHead.msg == ''">
	<div class="col-lg-6 col-md-8 col-xs-12">
		 <alert [alert]="msgHead"></alert>
	</div>
	</div>
	<div class="row">
	<div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px;">
			<form [formGroup]="form" novalid>
				<div class="row">
					<div class="col-lg-3 col-md-6 col-xs-12">
						<div class="form-group">
							<p class="custom-label">Service</p>
							<select [(ngModel)]="data.serviceId" formControlName="svc" (change)="displayServiceRoles()" class="form-control" title="Service">
								<option *ngFor="let svc of services; let i = index" [value]="svc.id">{{svc.title}}</option>
							</select>
						</div>
						<div *ngIf="!hideOrgInput" class="form-group">
							<p class="custom-label">Organization</p>
							<select formControlName="orgAcctNumber" class="form-control" title="Organization">
								<option *ngFor="let org of orgs; let i = index" [value]="org.id">{{org.title}}</option>
							</select>
						</div>
						<div class="form-group">
							<p class="custom-label">Service Roles</p>
							<div *ngFor="let role of serviceRoles" class="checkbox">
								<label>
									<input [(ngModel)]="role.value" type="checkbox" [ngModelOptions]="{standalone: true}"> {{ role.title }}
								</label>
							</div>
						</div>
					</div>
				</div>
			</form>
			<div class="col-lg-4 col-md-8 col-xs-8">
	</div>
		</div>
	</div>
	<div class="row">
		<div class="col-lg-12 col-md-12 col-xs-12">
			<button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
			<a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
		</div>
	</div>
	<div class="row" [hidden]="msg.msg == ''">
		<div class="col-lg-6 col-md-8 col-xs-12">
			<alert [alert]="msg"></alert>
		</div>
	</div>
    